import nullifyData from '../../assets/icons/removeData.svg'
import nullifyDataLight from '../../assets/icons/nullifyData_bluish.svg'
import enableData from '../../assets/icons/tickData.svg'
import enableDataLight from '../../assets/icons/tickData_bluish.svg'
import { ButtonWithTooltip } from './ButtonWithTooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo'

interface BlockDataBntProps {
    state: boolean
    onClick: () => void
    className?: string
    isLight?: boolean
}

export const BlockDataBtn = (props: BlockDataBntProps) => {
    const { state, onClick, className, isLight } = props

    const tooltipMsg = !state ? (
        'Enable block'
    ) : isLight ? (
        'Disable block'
    ) : (
        <span
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
            }}
        >
            <span>Disable block</span>
            <span>
                <FontAwesomeIcon icon={faCircleInfo} />
                &nbsp;
                <span style={{ color: '#A3A3A3', fontSize: '12px' }}>
                    Block data will be deleted
                </span>
            </span>
        </span>
    )

    const enableImg = isLight ? enableDataLight : enableData
    const disableImg = isLight ? nullifyDataLight : nullifyData
    const btnIcon = (
        <img
            src={!state ? enableImg : disableImg}
            alt="Block data button"
        />
    )

    return (
        // @ts-ignore
        <ButtonWithTooltip tooltip={tooltipMsg}>
            <button
                style={{ width: '2rem' }}
                className={`btn-clean ${className}`}
                onClick={onClick}
            >
                {btnIcon}
            </button>
        </ButtonWithTooltip>
    )
}
